import React, { Component } from 'react';
import MapController from '../helpers/map';
import MapFilter from './MapFilter';
import MapFitBounds from './MapFitBounds';
import AddressContextMenu from './AddressContextMenu';

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = { contextMenu: { x: undefined, y: undefined, address: undefined } };
    this.onFitBoundsClick = this.onFitBoundsClick.bind(this);
    this.onOpenAddressContextMenu = this.onOpenAddressContextMenu.bind(this);
    this.onCloseAddressContextMenu = this.onCloseAddressContextMenu.bind(this);
    this.mapController = new MapController();
    this.mapRef = React.createRef();
  }

  onFitBoundsClick() {
    this.mapController.fitMapToVisibleMarkers();
  }

  componentDidMount() {
    this.mapController.init({ mapReference: this.mapRef.current });
    this.mapController.setOnMarkerContextMenuCallback(this.onOpenAddressContextMenu);
  }

  componentWillUnmount() {
    this.mapController.finalize();
  }

  onOpenAddressContextMenu(x, y, address) {
    const rect = this.mapRef.current.getBoundingClientRect();
    this.setState({ contextMenu: { x: x + rect.x, y: y + rect.y, address } });
  }

  onCloseAddressContextMenu() {
    this.setState({ contextMenu: { x: undefined, y: undefined, address: undefined } });
  }

  render() {
    const { contextMenu } = this.state;
    const mapStyle = { position: 'absolute', width: '100%', height: '100%' };
    const filterStyle = { position: 'absolute', margin: '8px' };
    const fitBoundsStyle = { position: 'absolute', margin: '8px', right: '0' };
    return (
      <React.Fragment>
        <div ref={this.mapRef} style={mapStyle}/>
        <div style={filterStyle}>
          <MapFilter/>
        </div>
        <div style={fitBoundsStyle}>
          <MapFitBounds onClick={this.onFitBoundsClick}/>
        </div>
        <AddressContextMenu x={contextMenu.x} y={contextMenu.y} address={contextMenu.address} onClose={this.onCloseAddressContextMenu}/>
      </React.Fragment>
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map.js